<template>
  <div class="wrap clear_a">
    <div class="page-tilt">
      <b></b>
      <span>AI摄像头预警详情</span>
    </div>
    <el-table v-loading="loading" element-loading-text="数据正在努力加载中" :border="true"
              :resizable="true" :data="tableData" class="table-div">
      <!-- <el-table-column type="selection" label="" width="50"></el-table-column> -->
      <el-table-column show-overflow-tooltip prop="pdtName" min-width="190" label="异常类型">
        <template slot-scope="scope">{{scope.row.warningTypeStr}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="warningDate" min-width="150" label="预警时间">
      </el-table-column>
      <el-table-column prop="screenshotUrl" min-width="100" label="异常截图">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px" :src="scope.row.screenshots"
                    :preview-src-list="[scope.row.screenshots]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="cameraPosition" min-width="100"
                        label="摄像头点位名称">
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="handleStatusStr" min-width="100" label="处理状态" v-if="isNjAreaCode"></el-table-column>
      <el-table-column show-overflow-tooltip prop="handleTypeStr" min-width="100" label="处理方式" v-if="isNjAreaCode"></el-table-column>
      <el-table-column show-overflow-tooltip prop="handleDeptStr" min-width="100" label="处理部门" v-if="isNjAreaCode"></el-table-column>
      <el-table-column show-overflow-tooltip prop="handlePerson" min-width="100" label="处理人" v-if="isNjAreaCode"></el-table-column>
      <el-table-column show-overflow-tooltip prop="handleTime" min-width="100" label="处理时间" v-if="isNjAreaCode"></el-table-column>
      <el-table-column show-overflow-tooltip prop="handleRemark" min-width="100" label="处理备注" v-if="isNjAreaCode"></el-table-column>
      <el-table-column min-width="120" label="处理附件" v-if="isNjAreaCode">
        <template slot-scope="scope">
          <div v-if='scope.row.urlList_.length>0' style="width: 100px; height: 100px">
            <el-image style="width: 100px; height: 100px" :src="scope.row.urlList_[0]" :preview-src-list="scope.row.urlList_">
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="200" fixed="right" v-if="isNjAreaCode">
        <template slot-scope="scope">
          <a href="javascript:;" class="operate-a" v-if="scope.row.handleStatus == 0" @click="dispose(scope.row)">处理</a>
          <a href="javascript:;" class="operate-a" v-if="scope.row.handleStatus == 1">已处理</a>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination background @size-change="pageSizeChange"
                      @current-change="pageCurrentChange" :current-page="tableLimit.pageNum"
                      :page-sizes="[10, 20, 30, 40,50]" :page-size="tableLimit.pageSize"
                      layout="total, sizes, prev, pager, next, jumper" :total="page.total">
      </el-pagination>
    </div>
    <Dialog :isAssess="true" :dialogData="dialogData" url="/early/warning/ai/detail/handle" :showTip="disposeDialog" v-if="disposeDialog"
      @refresh="disposeRefresh" @cancel="disposeDialog=false" :handle="methodOptionsArr">
    </Dialog>
  </div>
</template> 

<script>
import * as api from 'api/warning_v3.js';
import Dialog from './public/disposeDialog';
import Cookies from "js-cookie";
export default {
  components:{Dialog},
  data() {
    return {
      warningType: "0202",
      page: {
        total: 0
      },
      schoolTraceBaseUrl: '',
      loading: false,
      tableData: [],
      tableLimit: {
        entityId:'',
        warningId: '',
        pageNum: 1,
        pageSize: 10,
      },
      warning: {},
      methodOptionsArr: [],
      disposeDialog:false,
      dialogData: {
        id: "",
        title: "",
        handlePerson: "",
        handleRemark: "",
        defaultDeduction: 0,
        fidList: []
      },
      isNjAreaCode: Cookies.get('areaId').substr(0, 4)=='5110',//是否为内江账号511000
    };
  },
  async mounted() {
    this.tableLimit.entityId = this.$store.state.common.user.deptId;
    this.tableLimit.warningId = this.$route.query.id;
    this.schoolTraceBaseUrl = this.$store.state.common.baseUrl;
    this.searchTab();
    this.initSelectData();
  },
  methods: {
    async searchPage() {
      this.loading = true;
      let result = await api.getAIDetail(this.tableLimit)
      if (result.code == 200) {
        this.tableData = [];
        result.data.records.map(item1 => {
          if (item1.handAnnex && item1.handAnnex.length > 0) {
            let arr = item1.handAnnex.map(item => this.schoolTraceBaseUrl + "/" + item.fileUrl)
            this.$set(item1, 'urlList_', arr)
          } else {
            this.$set(item1, 'urlList_', [])
          }
          this.tableData.push(item1)
        })
        this.page.total = result.data.total
      } else {
        this.$message.warning(result.message);
      }
      this.loading = false;
    },
    searchTab() {
      this.tableLimit.pageNum = 1;
      this.searchPage();
    },
    pageCurrentChange(num) {
      this.tableLimit.pageNum = num;
      this.searchPage();
    },
    pageSizeChange(size) {
      this.tableLimit.pageSize = size;
      this.searchPage();
    },
    // [{value: '', key: ''}] => {key: value}
    array2Object(arr = []) {
      let obj = {};

      arr.forEach(item => {
        obj[item.key] = item.value;
      })

      return obj;
    },
    dispose(row) {
      this.dialogData.title = "预警处理";
      this.dialogData.id = row.id;
      this.dialogData.warningType = row.warningType;
      this.dialogData.warningId = row.id;
      this.dialogData.entityId = this.tableLimit.entityId;
      this.dialogData.warningDate = row.warningDate;
      this.disposeDialog = true;
    },
    initSelectData() {
      // 获取 处理方式
      api.getHandleType({ warningType: this.warningType })
        .then(data => {
          if (data.code === 200) {
            this.methodOptionsArr = data.data;
          }
        });
    },
    disposeRefresh() {
      this.searchPage();
    },
  }
};
</script>
<style scoped lang="scss">
.wrap {
  width: calc(100% - 40px);
  padding: 20px 30px;
  min-height: calc(100% - 125px);
  background: #fff;
  border-radius: 10px;
  margin:20px;
  box-sizing: border-box;
}
.ipt-btn-box {
  margin: 20px 0;

  span {
    line-height: 33px;
  }
}
.pagination-box {
  text-align: right;
  margin-top: 20px;
}
.table-div {
  margin-top: 20px;
  width: 100%;
  text-align: center;
}
.operate-a {
  color: #1787ad;
}
table tr td:last-child .cell a {
  border-right: 1px solid #ccc;
  padding-right: 5px;
}
table tr td:last-child .cell a:last-child {
  border-right: none;
  padding-right: 0px;
}
</style>
